import ExpandLessRounded from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Backdrop,
  Box,
  Button,
  Card,
  CardActionArea,
  CardHeader,
  CircularProgress,
  Icon,
  IconButton,
  LinearProgress,
  Skeleton,
  Snackbar,
  Typography,
  Zoom,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Fragment, useEffect, useState } from "react";
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";
import { v4 as uuidv4 } from "uuid";
import mime from "mime";
import { AddAPhoto, Delete } from "@mui/icons-material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Tooltip } from "antd";

import * as $ from "jquery";
import { docs_enum, getFileExtention } from "utils/helper";
import CardButton from "components/CardButton";
import { useBoundStore } from "store/store";
import i18n from "i18n/i18n";
import { ReactComponent as AttachmentAvatar } from "assets/Svgs/AttachmentHr.svg";

function DragAndDropAccordian(props) {
  const createAttachment = useBoundStore((state) => state.createAttachment);
  const isLoggedIn = useBoundStore((state) => state.isLoggedIn);

  const loadEquipmentDetails = useBoundStore(
    (state) => state.loadEquipmentDetails
  );

  const resetFilesFlag = useBoundStore((state) => state.resetFilesFlag);

  const lang = useBoundStore((state) => state.lang);

  let itemId = props.item.id.replace(" ", "_");

  const [expanded, setExpanded] = useState("");

  const allFilesUploaded = useBoundStore((state) => state.allFilesUploaded);

  const [uploadProgress, setUploadProgress] = useState(0);

  const [hasInvalidFiles, setHasInvalidFiles] = useState([]);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setHasInvalidFiles([]);
  };

  const valedateDocument = (file) => {
    return file && file.type.length && docs_enum.includes("application");
  };

  const handleProgress = (progressEvent) => {
    const percent = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    console.log(uploadProgress);
    setUploadProgress(percent);
  };

  const createGenericAttachment = async (file, specifier) => {
    var localURL = file ? URL.createObjectURL(file) : null;

    const attachment = {
      attachment: {
        description: null,
        file: {
          localuri: localURL,
          mimetype: file?.type,
        },
      },
    };

    let _file = [];
    _file.push(attachment);

    const obj = {};
    obj["title"] = file?.name.split(".")[0];
    obj["description"] = "";
    obj["lang"] = lang;
    obj["isattachmentof"] = props.machines?.equipment?.nodeid
      ? props.machines?.equipment?.nodeid
      : "";
    obj["attachments"] = _file;
    obj["specifier"] = specifier;

    const promises = [
      createAttachment(
        obj,
        props.machines?.equipment?.nodeid
          ? props.machines?.equipment?.nodeid
          : ""
      ),
    ]; // Ensure that promises is an array

    return promises;
  };

  const handleChangeDropFile = async (e) => {
    // setLoading("dropzone-" + itemId);

    $("#dropzone-" + itemId).hide();
    $(`#${itemId}-header-summary`).css("background-color", "transparent");
    $(".docsDetails-" + itemId).show();

    const files = Array.from(e.target.files); // Handle multiple files
    if (files.length === 0) {
      return false;
    }

    let filesStatus = [];

    for (const file of files) {
      filesStatus.push({
        file: file,
        status: valedateDocument(file),
      });
    }

    let validFiles = filesStatus.filter((file) => {
      return file.status === true;
    });
    let invalidFiles = filesStatus.filter((file) => {
      return file.status === false;
    });

    if (invalidFiles.length) {
      setHasInvalidFiles(invalidFiles);
    }

    const user_token = sessionStorage.getItem("accessToken");

    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user_token,
      },
    };

    let promises = [];

    for (const file of validFiles) {
      const targetFile = file.file;
      promises.push(createGenericAttachment(targetFile, itemId)); // returns a Promise
    }

    if (isLoggedIn === true) {
      try {
        // Wait for all file uploads to complete
        const result = await Promise.all(promises);

        // Optional: wait a bit before loading equipment details
        // await new Promise((resolve) => setTimeout(resolve, 2000)); // 1 second delay
      } catch (error) {
        console.error(
          "Error during file uploads or loading equipment details:",
          error
        );
      }
    }

    // Update UI after processing files
    $("#dropzone-" + itemId).hide();
    $(`#${itemId}-header-summary`).css("background-color", "transparent");
    $(".docsDetails-" + itemId).show();
    // setLoading("");
  };

  useEffect(() => {
    $("#dropzone-" + itemId).hide();

    var dragTimer;
    $(".docsWrapper-" + itemId).on("dragover", function (e) {
      $(".docsDetails-" + itemId).hide();
      var dt = e.originalEvent.dataTransfer;
      if (
        dt.types &&
        (dt.types.indexOf
          ? dt.types.indexOf("Files") != -1
          : dt.types.contains("Files"))
      ) {
        setExpanded(itemId);

        $("#dropzone-" + itemId).show();
        $(`#${itemId}-header-summary`).css("background-color", "#ECF0F1");
        window.clearTimeout(dragTimer);
      }
    });
    $(".docsWrapper-" + itemId).on("dragleave", function (e) {
      dragTimer = window.setTimeout(function () {
        setExpanded("");
        $("#dropzone-" + itemId).hide();
        $(`#${itemId}-header-summary`).css("background-color", "transparent");
        $(".docsDetails-" + itemId).show();
      }, 25);
    });
  }, []);

  useEffect(() => {
    if (allFilesUploaded) {
      // Now safe to call loadEquipmentDetails
      loadEquipmentDetails(props.machines?.equipment?.nodeid, lang);
      resetFilesFlag();
    }
  }, [allFilesUploaded]);

  let attachmentsByCategory =
    props.machines.equipment && props.machines.equipment.hasattachment
      ? props.machines.equipment.hasattachment.filter((attachment) => {
          return attachment.attachment.specifier === props.item.id;
        })
      : [];

  return (
    <div className={"docsWrapper-" + itemId} style={{ width: "100%" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={hasInvalidFiles.length}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        TransitionComponent={Zoom}
      >
        <Alert severity={"error"} sx={{ width: "100%" }} className="bxShadow">
          <Tooltip
            zIndex={11111}
            title={
              <div>
                {" "}
                Es sind nur (Text, PDF, Word, Excel) Dateien zulässig!{" "}
              </div>
            }
            placement="bottomLeft"
          >
            <div>
              {" "}
              <b>Ungültiger Dateityp!</b>{" "}
            </div>
          </Tooltip>

          <ul>
            {hasInvalidFiles.length &&
              hasInvalidFiles.map((file, k) => {
                return (
                  <li key={k}>
                    {" "}
                    <b>{file.file.name}</b> {" : " + file.file.type}{" "}
                  </li>
                );
              })}
          </ul>
        </Alert>
      </Snackbar>

      {allFilesUploaded === false ? (
        <Backdrop
          open={allFilesUploaded === false}
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.modal + 1,
            backdropFilter: "blur(4px)",
            flexDirection: "column",
            opacity:0
          }}
        >
          <CircularProgress color="inherit" />
          <Typography sx={{ mt: 2 }}>Hochladen läuft..., bitte nicht schließen.</Typography>
        </Backdrop>
      ) : (
        ""
      )}

      <Accordion
        expanded={expanded === itemId}
        onChange={handleChange(itemId)}
        sx={{
          borderRadius: "4px",
          border: "1px solid #e0e0e0",
          width: "100%",
        }}
      >
        <AccordionSummary
          aria-controls={`${itemId}-content`}
          id={`${itemId}-header-summary`}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography
                variant="h6"
                sx={{ color: "var( --primary-second-color)", fontSize: "16px" }}
              >
                {props.item.category[lang]} ({attachmentsByCategory.length})
              </Typography>
              <div style={{ marginLeft: "5px", display: "flex" }}>
                {expanded === itemId ? (
                  <ExpandLessRounded
                    color="inherit"
                    style={{ opacity: "0.5" }}
                  />
                ) : (
                  <ExpandMoreRounded
                    color="inherit"
                    style={{ opacity: "0.5" }}
                  />
                )}
              </div>
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            padding: "0px",
          }}
        >
          <div className="dropzone" id={"dropzone-" + itemId}>
            <div className="svg">
              <AttachmentAvatar />
            </div>
            <div className="title">{i18n(lang).dropzone_dialog_title}</div>
            <input multiple type="file" onChange={handleChangeDropFile} />
          </div>

          <div
            className={"docsDetails-" + itemId}
            style={{
              width: "100%",
              padding: "0% 2%",
              minHeight: attachmentsByCategory.length ? "max-content" : "200px",
            }}
          >
            <>
              {attachmentsByCategory.length > 0 ? (
                attachmentsByCategory.map((item, key) => {
                  let mimeType = mime.getExtension(
                    item.attachment.file.mimetype
                  );
                  return (
                    <Fragment key={key}>
                      <CardButton
                        isVideo={item.attachment.file.mimetype.includes(
                          "video"
                        )}
                        pdfUrl={item.attachment.file.url}
                        fileMime={mimeType}
                        file={item.attachment.file}
                        type="internal"
                        fileid={item.attachment.fileid}
                        nodeid={item.attachment.nodeid}
                        fromDragAndDrop
                        title={
                          item.attachment.title != undefined
                            ? item.attachment.title
                            : "No Title"
                        }
                        description={
                          item.attachment.description != undefined
                            ? item.attachment.description
                            : ""
                        }
                        icon={<PictureAsPdfIcon />}
                        size="large"
                        setAttachmentCategory={props?.setAttachmentCategory}
                        attachmentCategory={item.attachment.specifier}
                        machineNodeId={props.machines?.equipment?.nodeid}
                      />
                    </Fragment>
                  );
                })
              ) : (
                <>
                  <LibraryAddOutlinedIcon
                    sx={{
                      fontSize: 40,
                      opacity: "0.5",
                      width: "24px",
                      height: "24px",
                      mt: 2,
                      mb: 1.2,
                    }}
                  />
                  <Typography variant="h6">
                    {i18n(lang).dnd_empty_title}
                  </Typography>
                  <Typography variant="caption" style={{ opacity: 0.5 }}>
                    {i18n(lang).dnd_empty_desc_1}
                    <br /> {i18n(lang).dnd_empty_desc_2}
                  </Typography>
                  <br />
                  <Button
                    variant="contained"
                    sx={{
                      marginTop: 2,
                      marginBottom: 4,
                      backgroundColor: "#b21412",
                    }}
                    onClick={() => {
                      props.setAttachmentCategory(props.item.id);
                      props.handleClickOpenInternal();
                    }}
                  >
                    + {i18n(lang).upload_file}
                  </Button>
                </>
              )}
            </>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default DragAndDropAccordian;
